<template>
  <div
    class="modal fade"
    id="import-bookings-from-file"
    aria-hidden="false"
    aria-labelledby="exampleGrid"
    role="dialog"
  >
    <div class="modal-dialog modal-simple modal-center">
      <div class="modal-content" v-if="activeStep === 1">
        <div class="modal-header">
          <div class="container">
            <div class="row header">
              <div class="col-8">
                <h4 class="modal-title">
                  {{ $t("rentals.detail.import.from_file") }}
                </h4>
              </div>
              <div class="col-4">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click.prevent="closeModal('#import-bookings-from-file')"
                >
                  <span aria-hidden="true" class="close-btn">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row-mt-15">
            <div class="col-7 text-center">
              <p class="mt-15 modal-description">
                {{ $t("rentals.detail.import.title") }}
              </p>
            </div>
          </div>
        </div>
        <v-loading
          :isLoading="smallLoading"
          :height="50"
          :width="50"
          :viewbox="'0 0 50 50'"
          :cx="25"
          :cy="25"
          :r="22"
          :isHeightAuto="true"
        ></v-loading>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn waves-effect waves-classic btn-cancel"
            @click.prevent="closeImportBookingsModal()"
            data-dismiss="modal"
            :disabled="smallLoading"
          >
            {{ $t("button.cancel") }}
          </button>
          <div class="upload">
            <button
              type="submit"
              class="btn btn-primary waves-effect waves-classic btn-save"
              :disabled="smallLoading"
            >
              {{ $t("rentals.detail.import.from_file") }}
            </button>
            <form enctype="multipart/form-data" v-if="!smallLoading">
              <input
                type="file"
                @change="importAndShowImportedFileFields"
                multiple
                class="import-notifications"
              />
            </form>
          </div>
          <div class="upload" v-if="fromRental">
            <button
              type="submit"
              class="btn btn-primary waves-effect waves-classic btn-save"
              :disabled="smallLoading"
            >
              {{ $t("rentals.detail.import.booking_reservations_from_file") }}
            </button>
            <form enctype="multipart/form-data" v-if="!smallLoading">
              <input
                type="file"
                @change="importBookingReservationsFromFile"
                multiple
                class="import-notifications"
              />
            </form>
          </div>
        </div>
      </div>
      <div class="modal-content second-step" v-if="activeStep === 2">
        <div class="modal-header">
          <div class="container">
            <div class="row header">
              <div class="col-8">
                <h4 class="modal-title">
                  {{ $t("rentals.detail.import.select_fields") }}
                </h4>
              </div>
              <div class="col-4">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click.prevent="closeImportBookingsModal()"
                >
                  <span aria-hidden="true" class="close-btn">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row-mt-15">
            <div class="col-7 text-center">
              <p class="mt-15 modal-description">
                {{ $t("rentals.detail.import.select_desc") }}
              </p>
            </div>
          </div>
          <div class="row align-items-end">
            <div class="col-6">
              <p class="mt-15">
                {{ $t("rentals.detail.import.select_channel") }}
              </p>
              <select class="form-control" v-model="selectedChannel">
                <option v-for="channel in channels" :value="channel.id">
                  {{ channel.name }}
                </option>
              </select>
            </div>
            <div class="col-6">
              <p class="mt-15 mb-20">
                {{ $t("rentals.detail.import.select_format") }}
              </p>
              <select class="form-control" v-model="selectedFormat">
                <option v-for="format in formats" :value="format">
                  {{ format }}
                </option>
              </select>
            </div>
          </div>
          <div class="row" v-if="!rentalId">
            <div class="col-12">
              <p class="mt-15 mb-10">{{ $t("analytics.index.rental") }}</p>
              <select class="form-control" v-model="selectedRentalId">
                <option v-for="rental in rentalsList" :value="rental.id">
                  <span>{{ rental.name }}</span>
                </option>
              </select>
            </div>
          </div>
        </div>
        <table
          id="imported-file-fields-table"
          class="
            bookings-table-sizes
            row-link
            table table-responsive table-margin
          "
        >
          <thead>
            <tr>
              <th>{{ $t("rentals.detail.import.column_to_import") }}</th>
              <th>{{ $t("rentals.detail.import.map_into_field") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="header in fileHeaders" v-if="header">
              <td>{{ header }}</td>
              <td>
                <select
                  id="booking-fields"
                  class="form-control"
                  @change="
                    collectBookingData(header, $event.target.value, $event)
                  "
                >
                  <option :value="null">
                    {{ $t("button.do_not_import") }}
                  </option>
                  <option
                    :value="bookingField.name"
                    v-for="bookingField in bookingFields"
                  >
                    {{ $t(bookingField.code) }}
                  </option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <v-loading
          :isLoading="smallLoading"
          :height="50"
          :width="50"
          :viewbox="'0 0 50 50'"
          :cx="25"
          :cy="25"
          :r="22"
          :isHeightAuto="true"
        ></v-loading>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn waves-effect waves-classic btn-cancel"
            data-dismiss="modal"
            :disabled="smallLoading"
            @click.prevent="closeImportBookingsModal()"
          >
            {{ $t("button.cancel") }}
          </button>
          <div class="upload">
            <button
              type="submit"
              class="btn btn-primary waves-effect waves-classic btn-save"
              :disabled="smallLoading"
              @click.prevent="importBookingsData()"
            >
              {{ $t("button.next") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../../../../mixins/mixin";
import rentalService from "../../../../services/rental";
import channelService from "../../../../services/channel";

export default {
  name: "ImportBookingsFromFile",
  props: ["rentalId", "rentals", "fromRental"],
  data() {
    return {
      smallLoading: false,
      activeStep: 1,
      fileHeaders: [],
      bookingFields: {
        first_name: {
          code: "input.first_name",
          name: "first_name",
        },
        last_name: {
          code: "input.last_name",
          name: "last_name",
        },
        email: {
          code: "input.email",
          name: "email",
        },
        status: {
          code: "payments.index.status",
          name: "status",
        },
        phone: {
          code: "input.phone",
          name: "phone",
        },
        code: {
          code: "booking.detail.confirmation_code",
          name: "code",
        },
        nbr_adults: {
          code: "analytics.index.current_tab.nbr_adults",
          name: "nbr_adults",
        },
        nbr_children: {
          code: "analytics.index.current_tab.nbr_children",
          name: "nbr_children",
        },
        checking: {
          code: "calendar.booking-detail.checkin",
          name: "checking",
        },
        checkout: {
          code: "calendar.booking-detail.checkout",
          name: "checkout",
        },
        book_date: {
          code: "calendar.booking-detail.booking_date",
          name: "booking_date",
        },
        nights: {
          code: "input.nights",
          name: "nights",
        },
        price: {
          code: "input.price",
          name: "price",
        },
        notes: {
          code: "input.notes",
          name: "notes",
        },
        address: {
          code: "input.address",
          name: "address",
        },
        city: {
          code: "input.city",
          name: "city",
        },
        commission: {
          code: "input.concierge_percent_commission",
          name: "commission",
        },
        cleaning_fees: {
          code: "input.cleaning_fees",
          name: "cleaning",
        },
        city_taxes: {
          code: "input.city_taxes",
          name: "city_taxes",
        },
      },
      bookingData: {},
      fileName: "",
      selectedChannel: 54,
      formats: ["d/m/Y", "m/d/Y", "d-m-Y", "m-d-Y", "Y-m-d"],
      selectedFormat: "d/m/Y",
      channels: [],
      selectedRentalId: "",
      rentalsList: [],
    };
  },
  components: {
    VLoading: require("components/loading/loading.vue"),
  },
  mixins: [mixin],
  mounted() {
    this.activeStep = 1;
  },
  methods: {
    async importAndShowImportedFileFields(event) {
      this.smallLoading = true;
      await this.getChannels();
      if (this.rentals) {
        this.rentalsList = this.rentals.filter(
          (rental) => !rental.hasOwnProperty("rental_fake_id")
        );
      }
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) {
        return;
      }
      const formData = new FormData();
      formData.append("file", files[0]);
      formData.append("folder", "bookings");
      rentalService.importBookingsFromFile(this, formData);
    },

    async importBookingReservationsFromFile(event) {
      this.smallLoading = true;
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) {
        return;
      }
      const formData = new FormData();
      formData.append("rentalId", this.rentalId);
      formData.append("file", files[0]);
      formData.append("folder", "bookings");
      rentalService.importBookingReservationsFromFile(this, formData);
    },

    closeImportBookingsModal() {
      this.activeStep = 1;
      this.bookingData = {};
      this.selectedRentalId = "";
      this.closeModal("#import-bookings-from-file");
    },

    collectBookingData(bookingField, bookingValue) {
      const bookingData = { ...this.bookingData };
      const currentFieldKey = Object.keys(bookingData).find(
        (key) => bookingData[key] === bookingField
      );
      if (bookingValue) {
        bookingData[bookingValue] = bookingField.trim();
      } else {
        delete bookingData[currentFieldKey];
      }
      this.bookingData = bookingData;
    },
    importBookingsData() {
      this.smallLoading = true;
      this.bookingData.format = this.selectedFormat;
      const data = {
        rentalId: this.rentalId ? this.rentalId : this.selectedRentalId,
        bookingData: this.bookingData,
        fileName: this.fileName,
        channelId: this.selectedChannel,
      };
      rentalService.importBookingsData(this, data);
    },
    getChannels() {
      channelService.get(this, true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ImportBookingsFromFile.vue?dc85ce7e